// Admin authentication utility
const ADMIN_EMAIL = 'admin@cashflow.com';
const ADMIN_PASSWORD = 'Paramjeet@admin';
const AUTH_STORAGE_KEY = 'admin_auth';

// Check if admin is authenticated
export const isAdminAuthenticated = () => {
  try {
    const authData = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!authData) return false;
    
    const parsed = JSON.parse(authData);
    // Check if session is still valid (24 hours)
    const now = new Date().getTime();
    if (now > parsed.expiresAt) {
      logout();
      return false;
    }
    
    return parsed.authenticated === true && parsed.email === ADMIN_EMAIL;
  } catch (error) {
    return false;
  }
};

// Authenticate admin
export const loginAdmin = (email, password) => {
  if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
    const expiresAt = new Date().getTime() + (24 * 60 * 60 * 1000); // 24 hours
    const authData = {
      authenticated: true,
      email: email,
      expiresAt: expiresAt
    };
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
    return true;
  }
  return false;
};

// Logout admin
export const logout = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

